import axios from "axios";
import {AxiosRequestConfig, Method} from "axios";

const axiosInstance = axios.create({
    timeout: 30000,
});

export const request = (method, url, data, config) => {
    // const prefix = "http://api-invnt-test.cabbagesoft.com";
    // const prefix = "http://172.105.42.161:3015";
    const prefix = process.env.REACT_APP_API_ENDPOINT;

    url = prefix + url;

    if (method === "post") {
        return axiosInstance.post(url, data, config);
    } else {
        return axiosInstance.get(url, {
            params: data,
            ...config,
        });
    }
};
